import { OnProgressParams,UseImportInputPropsType } from '@refinedev/core';
import papaparse from 'papaparse';
import { useState } from 'react';

export type CSVReaderReturnType = {
  inputProps: UseImportInputPropsType;
  handleChange: ({ file }: any) => void;
  isLoading: boolean;
};

export type CSVReaderOptions = {
  paparseOptions?: papaparse.ParseConfig;
  onProgress?: (progressParams: OnProgressParams) => any;
  onFinish?: (results: any[]) => void;
};

export const useCSVReader = ({
  paparseOptions,
  onFinish,
}: CSVReaderOptions): CSVReaderReturnType => {
  const [isLoading, setIsLoading] = useState(false);

  const handleCleanup = () => {
    setIsLoading(false);
  };

  const handleFinish = (values: any[]) => {
    onFinish?.(values);
    setIsLoading(false);
  };

  const handleChange = ({ file }: any) => {
    handleCleanup();
    return new Promise<any[]>(resolve => {
      setIsLoading(true);
      papaparse.parse(file as any, {
        complete: async ({ data }: { data: unknown[][] }) => {
          // const values = importCSVMapper(data, mapData);
          // Create Chunk Processor Functions
          resolve(data);
        },
        ...paparseOptions,
      });
    }).then(results => {
      handleFinish(results);
      return results;
    });
  };

  return {
    inputProps: {
      type: 'file',
      accept: '.csv',
      onChange: (event: React.ChangeEvent<HTMLInputElement>) => {
        if (event.target.files && event.target.files.length > 0) {
          handleChange({ file: event.target.files[0] });
        }
      },
    },
    isLoading,
    handleChange,
  };
};
